module.exports = __webpack_public_path__ + "img/dropdown-search-ford.5e41334c.png";